export enum ECondition {
  SpentHours = 'spent_hours',
  SpentSumOnce = 'spent_sum_ones',
  SpentSumOverall = 'spent_sum_overall',
  AddDepositOnce = 'add_deposit_once',
  AddDepositOverall = 'add_deposit_overall',
  Register = 'register',
  ClubComment = 'club_comment',
  OnlineBooking = 'online_booking',
}

export enum EReward {
  AddDiscount = 'add_discount',
  AddDeposit = 'add_deposit',
  None = 'none',
}

export type TAchievement = {
  id: number;
  name: string;
  conditions: Array<{
    name: ECondition;
    value: number;
  }>;
  rewards: Array<{
    name: EReward;
    value: number;
  }>;
  created_at: string;
  assigned_count: number;
};

export interface IFilters {
  condition: ECondition | null;
  reward: EReward | null;
}

export interface IDeleteAchievementRequest {
  id: number;
}
export interface IDeleteAchievementResponse {
  deleteAchievement: {
    id: number;
  };
}

export interface IGetAchievementsResponse {
  achievements: Array<TAchievement>;
}
